import { useRef, useState } from "react";
import { Overlay } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";

interface SntTooltipProps {
  size?: number;
  className?: string;
  text: string | React.ReactNode;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const SntTooltip: React.FC<SntTooltipProps> = ({
  size = 16,
  className = "",
  text,
  icon,
  style = {},
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [show, setShow] = useState<boolean>(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleMouseEnter = () => {
    timerRef.current = setTimeout(() => {
      setShow(true);
    }, 500);
  };

  const handleMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setShow(false);
  };

  return (
    <span
      ref={ref}
      className={`${className}`}
      style={style}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {icon ? icon : <IcomoonIcon icon="info" size="16"></IcomoonIcon>}
      <Overlay target={ref.current} show={show}>
        {/* https://github.com/react-bootstrap/react-overlays/issues/312 */}
        {({
          placement,
          scheduleUpdate,
          arrowProps,
          outOfBoundaries,
          show,
          ...props
        }) => (
          <div className="snt-tooltip" {...props}>
            {text}
          </div>
        )}
      </Overlay>
    </span>
  );
};
export default SntTooltip;
